<template>
	<sideNav :page-title="pageTitle"></sideNav>
	<div v-show="showFlag">
		<div class="ld-panel-title">
			<h2>实名认证</h2>
		</div>
		<div class="ld-panel-main">
			<el-alert title="根据《中华人民共和国网络安全法》等网络安全相关法律法规规定，及公安网安、网信办、通管局等单位要求 ，云计算资源用户须完成用户实名认证才能使用云服务。请您认真填写相关实名认证信息，完成实名认证申请。" type="warning" show-icon :closable="false" />
			<div class="verify-info">
				<h4>选择认证类型</h4>
				<p>实名认证决定了账号归属，为了您的账号安全，请根据实际情况进行实名认证</p>
				<p>实名认证时，企业主体请尽量避免使用个人认证方式，以免企业人员变动或交接引起不必要的纠纷</p>
			</div>
			<div class="verify-type">
				<li class="per">
					<h4>个人认证</h4>
					<p>
						<span>适用个人用户，账号归属于个人</span>
						<span>免费体验云产品最多15天</span>
						<span>不支持开增值税专用发票</span>
					</p>
					<el-button type="primary" class="btn" @click="perClick">选择并继续</el-button>
				</li>
				<li class="ens">
					<h4>企业认证</h4>
					<p>
						<span>适用企业、政府、事业单位、学校、组织等，账号归属于企业</span>
						<span>免费体验云产品最长3个月，可享受企业专享活动，云产品低至1折</span>
						<span>免费获取1000条短信服务体验包</span>
					</p>
					<el-button type="primary" class="btn" @click="ensClick">选择并继续</el-button>
				</li>
			</div>
		</div>
		<el-dialog v-model="dialogVisible" title="提示" :show-close="false" :close-on-click-modal="false" align-center width="22%">
			<div class="tip-main"><el-icon class="icon" color="#E6A23C" :size="24" style="position: absolute;left: 0;top: 0;"><WarningFilled /></el-icon>根据《中华人民共和国网络安全法》等网络安全相关法律法规规定，云服务器使用者必须提供真实身份信息，请先进行实名认证！</div>
		    <template #footer>
		      <span class="dialog-footer">
		        <el-button type="primary" @click="dialogVisible = false">确认</el-button>
		      </span>
		    </template>
		</el-dialog>
	</div>
</template>

<script setup>
	import { ref,reactive,onMounted} from 'vue';
	import { useRouter } from 'vue-router';
	import { authInfo } from '@/api/auth';
	import { WarningFilled } from '@element-plus/icons-vue';
	import sideNav from '../../components/sideNav.vue';

	const router = useRouter();
	const pageTitle = 'account';
	const authData = ref('');
	const dialogVisible = ref(true);
	const showFlag = ref(false);
	
	const generData = () => {
		authInfo().then((res) => {
			if(res.code === 200){
				authData.value = res.data;
				showFlag.value = true
			}
		})
	};
	const perClick = () => {
		router.push({ path: '/verify/person' })
	}
	const ensClick = () => {
		router.push({ path: '/verify/business' })
	}
	
	onMounted(() => {
		generData()
	})
	
</script>

<style lang="scss" scoped>
	.verify-info{
		text-align: center;
		padding: 50px 0;
		overflow: hidden;
		h4{font-size: 18px; font-weight: bold; margin-bottom: 12px;}
		p{color: #666; margin-bottom: 3px;}
	}
	.verify-type{
		text-align: center;
		overflow: hidden;
		li{
			display: inline-block;
			vertical-align: top;
			border: 1px solid #ddd;
			margin: 0 16px;
			padding: 60px 30px 30px;
			width: 300px;
			cursor: pointer;
			h4{font-size: 18px; color: #333; margin-bottom: 16px;}
			p{
				height: 135px;
				text-align: left; 
				overflow: hidden;
				span{margin-bottom: 6px; line-height: 20px; position: relative; padding-left: 10px; display: block; color: #666; font-size: 12px;}
				span:before{content: "";width: 4px;height: 4px;background-color: #555; position: absolute;left: 0;top: 8px;}
			}
		}
		li:before{content: "";display: block;width: 68px;height: 67px;margin: 0 auto 24px;background: url(../../assets/images/auth.png) no-repeat;}
		li.per:before{background-position: -70px 0}
		li.ens:before{background-position: 0 0}
	}
	.tip-main{line-height: 22px;position: relative;padding-left: 30px; overflow: hidden;}

</style>